import { connect } from 'react-redux';
import {
  getEffectiveSegment,
  getHuggg,
  hasPrepaidCardVoucher,
} from 'redux/modules/huggg';
import Footer from './Footer';

const mapStateToProps = (state) => {
  return {
    huggg: getHuggg(state),
    hasPrepaidCardVoucher: hasPrepaidCardVoucher(state),
    segment: getEffectiveSegment(state),
  };
};

export default connect(mapStateToProps)(Footer);
